import { ComponentFunction } from "@glidejs/glide";
import Glide from "@glidejs/glide";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("AxProdMain")
export class AxProdMain implements AxInit {
    private Glides: Map<string, Glide.Static> = new Map<string, Glide.Static>();

    constructor() { }

    AxInit(init: any): void {
        $('.ax-products__groupList[data-display-mode="swiper"]').each((i, x) => {
            let glideID: string = $(x).attr('id');
            let rows: number = $(x).data('rows');

            let glide = new Glide('#' + glideID, {
                type: 'slider',
                perView: rows,
                rewind: false,
                bound: true,
                animationDuration: 300,
                breakpoints: {
                    800: {
                        perView: 2
                    },
                    480: {
                        perView: 1
                    }
                },
                classes: {
                    activeSlide: 'glide__slide--active',
                    disabledArrow: 'glide__arrow--disabled'
                },
                gap: 0
            });

            this.Glides.set(glideID, glide);

            glide.on('run.before', e => {
                e.steps = e.direction === '>' ? -glide.settings.perView : glide.settings.perView
            })
            glide.mount({
                'DisableControls': this.updateGlideFunc
            });
        });        

        $('[data-category]').on('click', (e) => {
            var dataCategoryId = $(e.currentTarget).data('category-id');            

            $('[data-category-list]').addClass('d-none');
            $(`[data-product-category][data-category-id="${dataCategoryId}"]`).removeClass('d-none');

            $('.ax-products__groupList[data-display-mode="swiper"]').each((i, x) => {
                let glideID: string = $(x).attr('id');
                let rows: number = $(x).data('rows');

                let glide = new Glide('#' + glideID, {
                    type: 'slider',
                    perView: rows,
                    rewind: false,
                    bound: true,
                    animationDuration: 300,
                    breakpoints: {
                        800: {
                            perView: 2
                        },
                        480: {
                            perView: 1
                        }
                    },
                    classes: {
                        activeSlide: 'glide__slide--active',
                        disabledArrow: 'glide__arrow--disabled'
                    },
                    gap: 0
                });

                this.Glides.set(glideID, glide);

                glide.on('run.before', e => {
                    e.steps = e.direction === '>' ? -glide.settings.perView : glide.settings.perView
                })
                glide.mount({
                    'DisableControls': this.updateGlideFunc
                });
            });            
        });

        $('[data-back]').on('click', () => {
            $('[data-product-category]').addClass('d-none');
            $('[data-category-list]').removeClass('d-none');
        });
    }

    private updateGlideFunc: ComponentFunction = (glide: Glide.Static, Components: any, Events: any) => {

        const PREV_CONTROL_SELECTOR = "[data-glide-dir='<']";
        const NEXT_CONTROL_SELECTOR = "[data-glide-dir='>']";
        const component = {
            buildAfter() {
                this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
                this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
            },
            handleDisable() {
                const perView = glide.settings.perView;
                const slidesCount = Components.Html.slides.length;

                this.prevBtn.disabled = (glide.index <= 0);
                this.nextBtn.disabled = (glide.index >= slidesCount - perView);
            },
            mount() {
            }
        };

        Events.on("build.after", function () {
            component.buildAfter();
            component.handleDisable();
        });
        Events.on("run.after", function () {
            component.handleDisable();
        });
        return component;
    }
}

interface GliderMovement {
    direction: string;
    steps: string;
}
